/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists } from '../runtime';
import { GridTypeFromJSON, GridTypeToJSON, WidgetFromJSON, WidgetToJSON, } from './';
export function GridFromJSON(json) {
    return GridFromJSONTyped(json, false);
}
export function GridFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        id: json['id'],
        type: GridTypeFromJSON(json['type']),
        config: json['config'],
        DocumentId: json['DocumentId'],
        Widgets: !exists(json, 'Widgets') ? undefined : json['Widgets'].map(WidgetFromJSON),
    };
}
export function GridToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        id: value.id,
        type: GridTypeToJSON(value.type),
        config: value.config,
        DocumentId: value.DocumentId,
        Widgets: value.Widgets === undefined ? undefined : value.Widgets.map(WidgetToJSON),
    };
}
